module.exports = __webpack_public_path__ + "img/asterisk.b07fc856.svg";